// extracted by mini-css-extract-plugin
module.exports = {"row":"HandbookAddForm_row__3m9fg","actions":"HandbookAddForm_actions__JKjvK","textInput":"HandbookAddForm_textInput__37S5w","rouble":"HandbookAddForm_rouble__2bNM1"};